import { AlertMessage, Button, Stack, Text } from "flicket-ui";
import { useContext } from "react";
import { UserContext } from "~context";

export const MemberTicketsBanner = () => {
  const { authState } = useContext(UserContext);

  if (authState === "unauthenticated") {
    return (
      <AlertMessage
        mt={3}
        type="info"
        title={""}
        description={
          <Stack
            direction={{ _: "vertical", sm: "horizontal" }}
            gap={1}
            justifyContent="space-between"
            alignItems={{ _: "flex-start", sm: "center" }}
          >
            <Stack direction="vertical" gap="1/2">
              <Text variant="header.XS">Unlock Exclusive Member Tickets</Text>

              <Text variant="regular">
                Log in to view membership tickets. Only available to eligible
                members.
              </Text>
            </Stack>
            <Button
              variant="primary"
              size="sm"
              height={46}
              minWidth={{ sm: "auto" }}
              href="/login"
            >
              Member log in
            </Button>
          </Stack>
        }
      />
    );
  }

  if (authState === "authenticated") {
    return (
      <AlertMessage
        mt={3}
        type="success"
        title={"Member Tickets Unlocked"}
        description="You're currently viewing exclusive member tickets."
      />
    );
  }

  return null;
};
